import { render, staticRenderFns } from "./heim-textarea.vue?vue&type=template&id=43a50099&scoped=true&"
import script from "./heim-textarea.vue?vue&type=script&lang=js&"
export * from "./heim-textarea.vue?vue&type=script&lang=js&"
import style0 from "./heim-textarea.vue?vue&type=style&index=0&id=43a50099&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a50099",
  null
  
)

component.options.__file = "heim-textarea.vue"
export default component.exports